<template>
    <div class="single-team-container">
        <div class="team-logo">
          <img :src="$urlOrDefault(team.logo_picture,'logo')">
        </div>
        <div class="team-name">{{ teamData.name }}</div>
    </div>
</template>

<script>
    import Funcs from "@/functions";

    export default {
        name: "TeamList",
        props: {
            team: Object
        },
        data: function(){
            return {
                teamData: null,
            }
        },
        created: function(){
            this.teamData=this.$props.team;
        },
        methods: {
          getImageUrl: function(url){
            return Funcs.getImageUrl(url);
          }
        }
    }
</script>

<style scoped>
    .single-team-container {
        width: 100%;
        height: 190px;
        border-radius: 8px;
        background-color: #0A151C;
        padding: 5px;
        margin-top: 20px;
    }

    .single-team-container .team-logo {
        width: 100%;
        height: 130px;
        margin-top: 10px;
        text-align: center;
    }

    .single-team-container .team-logo > img {
        height: 130px;
    }

    .single-team-container .team-name {
        line-height: 30px;
        margin-top: 10px;
        height:30px;
        color:#FFF;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
    }
</style>